export default __webpack_public_path__ + "static/media/learning-how-electricity-changed-image.b62d77d4.jpg";